import React, { createContext, useContext, useState, useEffect } from 'react';
import { saveToIndexedDB, loadFromIndexedDB } from '../utils/localPostDB';

const LocalPostContext = createContext(null);

export const LocalPostProvider = ({ children }) => {
  const [rootHandle, setRootHandle] = useState(null);
  const [postsMap, setPostsMap] = useState({});
  const [folderName, setFolderName] = useState('');
  const [selectedPath, setSelectedPath] = useState([]);

  // IndexedDB에 저장 (postsMap이 업데이트될 때마다)
  useEffect(() => {
    if (Object.keys(postsMap).length > 0) {
      // FileHandle은 저장하지 않고 데이터만 저장
      const dataToSave = {
        postsMap: Object.fromEntries(
          Object.entries(postsMap).map(([id, post]) => [
            id,
            {
              id: post.id,
              title: post.title,
              body: post.body,
              filePath: post.filePath,
              parents: post.parents,
              children: post.children,
              created_at: post.created_at,
              updated_at: post.updated_at,
              needsHeaderUpdate: post.needsHeaderUpdate
            }
          ])
        ),
        folderName,
        selectedPath
      };
      saveToIndexedDB('localPosts', dataToSave).catch(err => {
        console.error('[LocalPostContext] IndexedDB 저장 실패:', err);
      });
    }
  }, [postsMap, folderName, selectedPath]);

  // 초기 로드: IndexedDB에서 복원
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const data = await loadFromIndexedDB('localPosts');
        if (data && data.postsMap) {
          console.log('[LocalPostContext] IndexedDB에서 데이터 복원:', Object.keys(data.postsMap).length, '개');
          // 참고: rootHandle은 복원할 수 없으므로 사용자가 다시 선택해야 함
          setFolderName(data.folderName || '');
          setSelectedPath(data.selectedPath || []);
          console.log('[LocalPostContext] selectedPath 복원:', data.selectedPath);
        }
      } catch (err) {
        console.error('[LocalPostContext] IndexedDB 로드 실패:', err);
      }
    };
    loadInitialData();
  }, []);

  const value = {
    rootHandle,
    setRootHandle,
    postsMap,
    setPostsMap,
    folderName,
    setFolderName,
    selectedPath,
    setSelectedPath
  };

  return (
    <LocalPostContext.Provider value={value}>
      {children}
    </LocalPostContext.Provider>
  );
};

export const useLocalPost = () => {
  const context = useContext(LocalPostContext);
  if (!context) {
    throw new Error('useLocalPost must be used within LocalPostProvider');
  }
  return context;
};

